import React, { Component } from 'react';
import PageTitle from './PageTitle';

export default class About extends Component {

    render() {
        return (
            <div>
                <PageTitle title="A FC Sistemas" last="Home" lastLink="/" />
                <section className="padding-top-90 padding-bottom-70">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10">

                                <div className="border-bottom-tab">

                                    <ul className="nav nav-tabs hidden-xs" role="tablist">
                                        <li role="presentation" className="active">
                                            <a href="#tab-1" role="tab" className="waves-effect waves-dark" data-toggle="tab" aria-expanded="false">Missão</a>
                                        </li>
                                        <li role="presentation" className="">
                                            <a href="#tab-2" role="tab" className="waves-effect waves-dark" data-toggle="tab" aria-expanded="false">Visão</a>
                                        </li>
                                        <li role="presentation" className="">
                                            <a href="#tab-3" role="tab" className="waves-effect waves-dark" data-toggle="tab" aria-expanded="true">Valores</a>
                                        </li>
                                    </ul>
                                    <div className="panel-group visible-xs" id="undefined-accordion">
                                    </div>

                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div role="tabpanel" className="tab-pane fade active in" id="tab-1">
                                                <img className="alignleft" src="/assets/img/mission.jpg" alt="" width="300px" />
                                                <p style={{fontSize: '19px'}}>
                                                    <br/>
                                                    Nossa missão é prover soluções em negócios simplificadas e intuitivas para problemas complexos, 
                                                    transformando o relacionando Usuário/Tecnologia favorável à nossos clientes.
                                                </p>
                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-2">
                                                <img className="alignleft" src="/assets/img/analysis.png" alt="" width="200px" />
                                                <p style={{fontSize: '19px'}}>
                                                    <br/>
                                                    Ser uma empresa de soluções em tecnologia reconhecida como a melhor opção no ramo de TI - (Tecnologia da informação) para seus clientes, 
                                                    colaboradores e fornecedores pela qualidade de nossos produtos, serviços e relacionamentos.
                                                </p>
                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-3">
                                                <img className="alignleft" src="/assets/img/business.png" alt="" width="180px" />
                                                
                                                <h4>Satisfação de nossos cliente</h4>
                                                <p>
                                                    Ele é a razão da existência de qualquer negócio.                                                   
                                                </p>
                                                <h4>Qualidade</h4>
                                                <p style={{fontSize: '19px'}}>
                                                    Buscar sempre a melhor forma.                                                   
                                                </p>
                                                <h4>Compromisso</h4>
                                                <p style={{fontSize: '19px'}}>
                                                    Inovação, ética, integridade e sempre buscar melhoria continua.                                               
                                                </p>                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/About.js